export const styles = {
  Heading: {
    margin: 0
  }
};
